import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function Header() {
  const [isArticleMenuOpen, setIsArticleMenuOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobileArticleOpen, setIsMobileArticleOpen] = useState(false);

  // メニューが開いている時はスクロールを無効化
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMobileMenuOpen]);

  return (
    <header className="fixed top-0 left-0 right-0 bg-white border-b border-gray-200 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-14 md:h-16">
          {/* ロゴ */}
          <Link to="/" className="flex items-center space-x-2 cursor-pointer">
            <div className="w-7 h-7 md:w-8 md:h-8 bg-gradient-to-br from-teal-500 to-emerald-600 rounded-lg flex items-center justify-center">
              <i className="ri-line-chart-line text-white text-base md:text-lg"></i>
            </div>
            <span className="text-base md:text-xl font-bold text-gray-900">DMM FX完全ガイド</span>
          </Link>

          {/* デスクトップナビゲーション */}
          <nav className="hidden lg:flex items-center space-x-8">
            <Link to="/" className="text-gray-700 hover:text-teal-600 font-medium transition-colors cursor-pointer">
              ホーム
            </Link>
            <Link to="/reviews" className="text-gray-700 hover:text-teal-600 font-medium transition-colors cursor-pointer">
              評判・口コミ
            </Link>
            <Link to="/account-opening" className="text-gray-700 hover:text-teal-600 font-medium transition-colors cursor-pointer">
              口座開設
            </Link>
            <Link to="/campaign" className="text-gray-700 hover:text-teal-600 font-medium transition-colors cursor-pointer">
              キャンペーン
            </Link>
            
            {/* 記事一覧ドロップダウン */}
            <div 
              className="relative"
              onMouseEnter={() => setIsArticleMenuOpen(true)}
              onMouseLeave={() => setIsArticleMenuOpen(false)}
            >
              <button className="text-gray-700 hover:text-teal-600 font-medium transition-colors flex items-center space-x-1 cursor-pointer">
                <span>記事一覧</span>
                <i className={`ri-arrow-down-s-line transition-transform ${isArticleMenuOpen ? 'rotate-180' : ''}`}></i>
              </button>
              
              {isArticleMenuOpen && (
                <div className="absolute top-full left-0 pt-2">
                  <div className="w-[720px] bg-white rounded-lg shadow-xl border border-gray-200 py-4 px-6">
                    <div className="grid grid-cols-3 gap-6">
                      {/* FX初心者ガイド */}
                      <div>
                        <Link 
                          to="/fx-guide" 
                          className="block text-sm font-bold text-teal-600 mb-3 hover:text-teal-700 cursor-pointer"
                        >
                          FX初心者ガイド
                        </Link>
                        <ul className="space-y-2">
                          <li><Link to="/beginner-guide" className="text-sm text-gray-700 hover:text-teal-600 cursor-pointer block">初心者でも大丈夫？</Link></li>
                          <li><Link to="/fx-basics" className="text-sm text-gray-700 hover:text-teal-600 cursor-pointer block">FXとは？超入門</Link></li>
                          <li><Link to="/minimum-amount" className="text-sm text-gray-700 hover:text-teal-600 cursor-pointer block">少額でいくらから？</Link></li>
                          <li><Link to="/safety" className="text-sm text-gray-700 hover:text-teal-600 cursor-pointer block">FXは危険？</Link></li>
                          <li><Link to="/account-opening" className="text-sm text-gray-700 hover:text-teal-600 cursor-pointer block">口座開設のやり方</Link></li>
                          <li><Link to="/demo-account" className="text-sm text-gray-700 hover:text-teal-600 cursor-pointer block">デモ口座は必要？</Link></li>
                          <li><Link to="/app-guide" className="text-sm text-gray-700 hover:text-teal-600 cursor-pointer block">アプリの使い方</Link></li>
                          <li><Link to="/how-to-choose" className="text-sm text-gray-700 hover:text-teal-600 cursor-pointer block">FX口座の選び方</Link></li>
                        </ul>
                      </div>

                      {/* FX基礎知識 */}
                      <div>
                        <Link 
                          to="/fx-basic" 
                          className="block text-sm font-bold text-amber-600 mb-3 hover:text-amber-700 cursor-pointer"
                        >
                          FX基礎知識
                        </Link>
                        <ul className="space-y-2">
                          <li><Link to="/leverage" className="text-sm text-gray-700 hover:text-teal-600 cursor-pointer block">レバレッジとは？</Link></li>
                          <li><Link to="/spread" className="text-sm text-gray-700 hover:text-teal-600 cursor-pointer block">スプレッドとは？</Link></li>
                          <li><Link to="/lot-guide" className="text-sm text-gray-700 hover:text-teal-600 cursor-pointer block">ロットとは？</Link></li>
                          <li><Link to="/fx-tax" className="text-sm text-gray-700 hover:text-teal-600 cursor-pointer block">税金いくらから？</Link></li>
                          <li><Link to="/economic-indicators" className="text-sm text-gray-700 hover:text-teal-600 cursor-pointer block">経済指標の見方</Link></li>
                          <li><Link to="/comparison" className="text-sm text-gray-700 hover:text-teal-600 cursor-pointer block">他社との比較</Link></li>
                          <li><Link to="/disadvantages" className="text-sm text-gray-700 hover:text-teal-600 cursor-pointer block">デメリット</Link></li>
                          <li><Link to="/trading-hours" className="text-sm text-gray-700 hover:text-teal-600 cursor-pointer block">取引時間</Link></li>
                        </ul>
                      </div>

                      {/* DMM FX取引ガイド */}
                      <div>
                        <Link 
                          to="/fx-trade" 
                          className="block text-sm font-bold text-emerald-600 mb-3 hover:text-emerald-700 cursor-pointer"
                        >
                          DMM FX取引ガイド
                        </Link>
                        <ul className="space-y-2">
                          <li><Link to="/reviews" className="text-sm text-gray-700 hover:text-teal-600 cursor-pointer block">評判・口コミ</Link></li>
                          <li><Link to="/campaign" className="text-sm text-gray-700 hover:text-teal-600 cursor-pointer block">キャンペーン情報</Link></li>
                          <li><Link to="/support" className="text-sm text-gray-700 hover:text-teal-600 cursor-pointer block">サポート情報</Link></li>
                          <li><Link to="/deposit-withdrawal" className="text-sm text-gray-700 hover:text-teal-600 cursor-pointer block">入出金方法</Link></li>
                          <li><Link to="/app-guide" className="text-sm text-gray-700 hover:text-teal-600 cursor-pointer block">アプリガイド</Link></li>
                          <li><Link to="/account-opening" className="text-sm text-gray-700 hover:text-teal-600 cursor-pointer block">口座開設手順</Link></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </nav>

          {/* デスクトップCTA */}
          <a 
            href="https://px.a8.net/svt/ejp?a8mat=4AX8OA+BW2OQA+1WP2+6JC82" 
            rel="nofollow"
            className="hidden lg:inline-flex items-center space-x-2 bg-gradient-to-r from-orange-500 to-orange-600 text-white px-5 py-2 rounded-lg font-bold hover:from-orange-600 hover:to-orange-700 transition-all whitespace-nowrap cursor-pointer shadow-md text-sm"
          >
            <span>無料口座開設</span>
            <i className="ri-arrow-right-line"></i>
          </a>
          <img border="0" width="1" height="1" src="https://www13.a8.net/0.gif?a8mat=4AX8OA+BW2OQA+1WP2+6JC82" alt="" style={{ display: 'none' }} />

          {/* モバイルメニューボタン */}
          <button 
            className="lg:hidden w-12 h-12 flex items-center justify-center text-gray-700 cursor-pointer -mr-2 active:bg-gray-100 rounded-full transition-colors"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="メニュー"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>

      {/* モバイルメニュー - オーバーレイ */}
      <div 
        className={`lg:hidden fixed inset-0 bg-black/40 transition-opacity duration-300 ${isMobileMenuOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
        style={{ top: '56px' }}
        onClick={() => setIsMobileMenuOpen(false)}
      />

      {/* モバイルメニュー */}
      <div 
        className={`lg:hidden fixed left-0 right-0 bg-white border-t border-gray-200 transition-all duration-300 ease-out ${isMobileMenuOpen ? 'translate-y-0 opacity-100' : '-translate-y-4 opacity-0 pointer-events-none'}`}
        style={{ top: '56px', maxHeight: 'calc(100vh - 56px)', overflowY: 'auto' }}
      >
        <nav className="px-4 py-3">
          {/* メインナビゲーション */}
          <div className="space-y-1">
            <Link 
              to="/" 
              className="flex items-center gap-3 py-4 px-4 text-gray-800 hover:bg-teal-50 active:bg-teal-100 rounded-xl font-medium cursor-pointer transition-colors"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              <div className="w-9 h-9 bg-teal-100 rounded-lg flex items-center justify-center">
                <i className="ri-home-4-line text-teal-600 text-lg"></i>
              </div>
              <span>ホーム</span>
            </Link>
            <Link 
              to="/reviews" 
              className="flex items-center gap-3 py-4 px-4 text-gray-800 hover:bg-teal-50 active:bg-teal-100 rounded-xl font-medium cursor-pointer transition-colors"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              <div className="w-9 h-9 bg-amber-100 rounded-lg flex items-center justify-center">
                <i className="ri-star-line text-amber-600 text-lg"></i>
              </div>
              <span>評判・口コミ</span>
            </Link>
            <Link 
              to="/account-opening" 
              className="flex items-center gap-3 py-4 px-4 text-gray-800 hover:bg-teal-50 active:bg-teal-100 rounded-xl font-medium cursor-pointer transition-colors"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              <div className="w-9 h-9 bg-emerald-100 rounded-lg flex items-center justify-center">
                <i className="ri-user-add-line text-emerald-600 text-lg"></i>
              </div>
              <span>口座開設</span>
            </Link>
            <Link 
              to="/campaign" 
              className="flex items-center gap-3 py-4 px-4 text-gray-800 hover:bg-teal-50 active:bg-teal-100 rounded-xl font-medium cursor-pointer transition-colors"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              <div className="w-9 h-9 bg-rose-100 rounded-lg flex items-center justify-center">
                <i className="ri-gift-line text-rose-600 text-lg"></i>
              </div>
              <span>キャンペーン</span>
            </Link>
          </div>

          {/* 記事一覧アコーディオン */}
          <div className="border-t border-gray-100 mt-3 pt-3">
            <button 
              className="w-full flex items-center justify-between py-4 px-4 text-gray-800 hover:bg-gray-50 active:bg-gray-100 rounded-xl font-medium cursor-pointer transition-colors"
              onClick={() => setIsMobileArticleOpen(!isMobileArticleOpen)}
            >
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 bg-gray-100 rounded-lg flex items-center justify-center">
                  <i className="ri-article-line text-gray-600 text-lg"></i>
                </div>
                <span>記事一覧</span>
              </div>
              <div className={`w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 transition-transform duration-300 ${isMobileArticleOpen ? 'rotate-180' : ''}`}>
                <i className="ri-arrow-down-s-line text-gray-600"></i>
              </div>
            </button>

            <div className={`overflow-hidden transition-all duration-300 ease-out ${isMobileArticleOpen ? 'max-h-[1000px] opacity-100' : 'max-h-0 opacity-0'}`}>
              <div className="pl-2 pr-2 pb-3 space-y-4">
                {/* FX初心者ガイド */}
                <div className="bg-teal-50/50 rounded-xl p-4">
                  <Link 
                    to="/fx-guide" 
                    className="flex items-center gap-2 text-sm font-bold text-teal-700 mb-3"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    <i className="ri-seedling-line"></i>
                    FX初心者ガイド
                  </Link>
                  <div className="grid grid-cols-2 gap-2">
                    <Link to="/beginner-guide" className="py-2.5 px-3 text-sm text-gray-700 hover:text-teal-600 bg-white rounded-lg active:bg-teal-50 transition-colors" onClick={() => setIsMobileMenuOpen(false)}>初心者でも大丈夫？</Link>
                    <Link to="/fx-basics" className="py-2.5 px-3 text-sm text-gray-700 hover:text-teal-600 bg-white rounded-lg active:bg-teal-50 transition-colors" onClick={() => setIsMobileMenuOpen(false)}>FXとは？超入門</Link>
                    <Link to="/minimum-amount" className="py-2.5 px-3 text-sm text-gray-700 hover:text-teal-600 bg-white rounded-lg active:bg-teal-50 transition-colors" onClick={() => setIsMobileMenuOpen(false)}>少額でいくらから？</Link>
                    <Link to="/safety" className="py-2.5 px-3 text-sm text-gray-700 hover:text-teal-600 bg-white rounded-lg active:bg-teal-50 transition-colors" onClick={() => setIsMobileMenuOpen(false)}>FXは危険？</Link>
                    <Link to="/account-opening" className="py-2.5 px-3 text-sm text-gray-700 hover:text-teal-600 bg-white rounded-lg active:bg-teal-50 transition-colors" onClick={() => setIsMobileMenuOpen(false)}>口座開設のやり方</Link>
                    <Link to="/demo-account" className="py-2.5 px-3 text-sm text-gray-700 hover:text-teal-600 bg-white rounded-lg active:bg-teal-50 transition-colors" onClick={() => setIsMobileMenuOpen(false)}>デモ口座は必要？</Link>
                    <Link to="/app-guide" className="py-2.5 px-3 text-sm text-gray-700 hover:text-teal-600 bg-white rounded-lg active:bg-teal-50 transition-colors" onClick={() => setIsMobileMenuOpen(false)}>アプリの使い方</Link>
                    <Link to="/how-to-choose" className="py-2.5 px-3 text-sm text-gray-700 hover:text-teal-600 bg-white rounded-lg active:bg-teal-50 transition-colors" onClick={() => setIsMobileMenuOpen(false)}>FX口座の選び方</Link>
                  </div>
                </div>

                {/* FX基礎知識 */}
                <div className="bg-amber-50/50 rounded-xl p-4">
                  <Link 
                    to="/fx-basic" 
                    className="flex items-center gap-2 text-sm font-bold text-amber-700 mb-3"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    <i className="ri-book-2-line"></i>
                    FX基礎知識
                  </Link>
                  <div className="grid grid-cols-2 gap-2">
                    <Link to="/leverage" className="py-2.5 px-3 text-sm text-gray-700 hover:text-amber-600 bg-white rounded-lg active:bg-amber-50 transition-colors" onClick={() => setIsMobileMenuOpen(false)}>レバレッジとは？</Link>
                    <Link to="/spread" className="py-2.5 px-3 text-sm text-gray-700 hover:text-amber-600 bg-white rounded-lg active:bg-amber-50 transition-colors" onClick={() => setIsMobileMenuOpen(false)}>スプレッドとは？</Link>
                    <Link to="/lot-guide" className="py-2.5 px-3 text-sm text-gray-700 hover:text-amber-600 bg-white rounded-lg active:bg-amber-50 transition-colors" onClick={() => setIsMobileMenuOpen(false)}>ロットとは？</Link>
                    <Link to="/fx-tax" className="py-2.5 px-3 text-sm text-gray-700 hover:text-amber-600 bg-white rounded-lg active:bg-amber-50 transition-colors" onClick={() => setIsMobileMenuOpen(false)}>税金いくらから？</Link>
                    <Link to="/economic-indicators" className="py-2.5 px-3 text-sm text-gray-700 hover:text-amber-600 bg-white rounded-lg active:bg-amber-50 transition-colors" onClick={() => setIsMobileMenuOpen(false)}>経済指標の見方</Link>
                    <Link to="/comparison" className="py-2.5 px-3 text-sm text-gray-700 hover:text-amber-600 bg-white rounded-lg active:bg-amber-50 transition-colors" onClick={() => setIsMobileMenuOpen(false)}>他社との比較</Link>
                    <Link to="/disadvantages" className="py-2.5 px-3 text-sm text-gray-700 hover:text-amber-600 bg-white rounded-lg active:bg-amber-50 transition-colors" onClick={() => setIsMobileMenuOpen(false)}>デメリット</Link>
                    <Link to="/trading-hours" className="py-2.5 px-3 text-sm text-gray-700 hover:text-amber-600 bg-white rounded-lg active:bg-amber-50 transition-colors" onClick={() => setIsMobileMenuOpen(false)}>取引時間</Link>
                  </div>
                </div>

                {/* DMM FX取引ガイド */}
                <div className="bg-emerald-50/50 rounded-xl p-4">
                  <Link 
                    to="/fx-trade" 
                    className="flex items-center gap-2 text-sm font-bold text-emerald-700 mb-3"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    <i className="ri-line-chart-line"></i>
                    DMM FX取引ガイド
                  </Link>
                  <div className="grid grid-cols-2 gap-2">
                    <Link to="/reviews" className="py-2.5 px-3 text-sm text-gray-700 hover:text-emerald-600 bg-white rounded-lg active:bg-emerald-50 transition-colors" onClick={() => setIsMobileMenuOpen(false)}>評判・口コミ</Link>
                    <Link to="/campaign" className="py-2.5 px-3 text-sm text-gray-700 hover:text-emerald-600 bg-white rounded-lg active:bg-emerald-50 transition-colors" onClick={() => setIsMobileMenuOpen(false)}>キャンペーン情報</Link>
                    <Link to="/support" className="py-2.5 px-3 text-sm text-gray-700 hover:text-emerald-600 bg-white rounded-lg active:bg-emerald-50 transition-colors" onClick={() => setIsMobileMenuOpen(false)}>サポート情報</Link>
                    <Link to="/deposit-withdrawal" className="py-2.5 px-3 text-sm text-gray-700 hover:text-emerald-600 bg-white rounded-lg active:bg-emerald-50 transition-colors" onClick={() => setIsMobileMenuOpen(false)}>入出金方法</Link>
                    <Link to="/app-guide" className="py-2.5 px-3 text-sm text-gray-700 hover:text-emerald-600 bg-white rounded-lg active:bg-emerald-50 transition-colors" onClick={() => setIsMobileMenuOpen(false)}>アプリガイド</Link>
                    <Link to="/account-opening" className="py-2.5 px-3 text-sm text-gray-700 hover:text-emerald-600 bg-white rounded-lg active:bg-emerald-50 transition-colors" onClick={() => setIsMobileMenuOpen(false)}>口座開設手順</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* モバイルCTA */}
          <div className="pt-4 pb-2 border-t border-gray-100 mt-3">
            <a 
              href="https://px.a8.net/svt/ejp?a8mat=4AX8OA+BW2OQA+1WP2+6JC82" 
              rel="nofollow"
              className="flex items-center justify-center gap-2 w-full bg-gradient-to-r from-teal-500 to-emerald-600 text-white py-4 rounded-xl font-bold cursor-pointer shadow-lg shadow-teal-500/20 active:scale-[0.98] transition-transform"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              <i className="ri-rocket-2-line text-lg"></i>
              <span>今すぐ無料で口座開設</span>
            </a>
            <p className="text-center text-xs text-gray-500 mt-2">
              <i className="ri-time-line mr-1"></i>
              最短5分で申込完了
            </p>
          </div>
        </nav>
      </div>
    </header>
  );
}
